import React from 'react';
import cn from 'classnames';

import './RsTableToolbar.scss';

const RsTableToolbar = ({ children, className }) => <div className={cn('rs-table-toolbar', className)}>{children}</div>;

export default RsTableToolbar;
